import n from "./td-longtail-vue-components164.js";
/* empty css                              */
import t from "./td-longtail-vue-components98.js";
var l = function() {
  var e = this, i = e._self._c;
  return i("div", { directives: [{ name: "touch", rawName: "v-touch:swipe.left", value: (() => {
    e.changeSlide(1);
  }), expression: `
    () => {
      changeSlide(1);
    }
  `, arg: "swipe", modifiers: { left: !0 } }, { name: "touch", rawName: "v-touch:swipe.right", value: (() => {
    e.changeSlide(-1);
  }), expression: `
    () => {
      changeSlide(-1);
    }
  `, arg: "swipe", modifiers: { right: !0 } }], ref: "sliderElement", staticClass: "slider", class: e.sliderClass, style: e.sliderStyles, attrs: { role: e.role, "aria-label": e.ariaLabel }, on: { focusin: e.focusin, pointerenter: e.hoverEnter, pointerleave: e.hoverLeave } }, [e.slideCount > 1 ? i("div", { staticClass: "slider-controls" }, [e._t("pagination", function() {
    return [i("Controls", { attrs: { "has-play-pause": e.autoplay > 0, "hide-pages-mobile": "", "infinity-scroll": "", pages: e.pages, "do-not-scroll-into-view": "", "pagination-next": "Nächste Slide", "pagination-prev": "Vorheriges Slide", "pagination-aria-label": "Slider Paginierung", "pagination-button-label": "Gehe zu Slide %d", "pagination-button-label-first": "Gehe zur ersten Slide", "pagination-button-label-last": "Gehe zur letzten Slide", "play-pause-aria-label": "Slider" }, on: { update: e.selectSlide }, model: { value: e.isPlaying, callback: function(a) {
      e.isPlaying = a;
    }, expression: "isPlaying" } })];
  })], 2) : e._e(), i("div", { ref: "sliderContent", staticClass: "slider__content" }, [e._t("default", null, { activeSliderIndex: e.activeSliderIndex })], 2)]);
}, r = [], s = /* @__PURE__ */ t(
  n,
  l,
  r,
  !1,
  null,
  "a5be55e0"
);
const u = s.exports;
export {
  u as default
};
